import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import type { ArcadiaGreenButtonSiteDataResponseDto } from "~/api/dto/arcadia-green-button.dto"

import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type LinkArcadiaGreenButtonProjectParams = {
  powurProjectId: number
  proposalId: string
  siteId: string
}

export const useLinkArcadiaGreenButtonProject = (): UseMutationResult<
  ArcadiaGreenButtonSiteDataResponseDto,
  unknown,
  LinkArcadiaGreenButtonProjectParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ powurProjectId, proposalId, siteId }) =>
      arcadiaGreenButtonService.linkExistingProject(
        siteId,
        powurProjectId,
        proposalId,
      ),
    onSuccess: (_data, { proposalId, siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
      // The linked import becomes a selectable candidate, and the usage views
      // are derived from whatever the proposal ends up selecting.
      void queryClient.invalidateQueries({
        queryKey: queryKeys.proposalConsumption.selection(proposalId),
      })
      void queryClient.invalidateQueries({
        queryKey: queryKeys.proposalConsumption.insights(proposalId),
      })
    },
  })
}
